import React from "react";
import GridHeader from "./Grid/GridHeader";
import { Alert, Container } from "reactstrap";
import GridBody from "./Grid/GridBody";
import withRouter from "../../components/Common/withRouter";
import { DF_LO0011Context } from "./context";

function DF_LO0011(props) {
  document.title = "Defender | Anular Documento de Transporte";
  const location = props.router.location;
  const parseParams = new URLSearchParams(location.search);

  if (!parseParams.get("ID_Arquivo")) {
    return (
      <Alert color="danger">
        Não é possível acessar essa transação sem parametros
      </Alert>
    );
  }

  return (
    <>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <DF_LO0011Context.Provider
        value={{
          parseParams,
        }}
      >
        <div className="page-content">
          <Container fluid={true} className="dataTable-custom-primary">
            <GridHeader />
            <GridBody />
          </Container>
        </div>
      </DF_LO0011Context.Provider>
    </>
  );
}

export default withRouter(DF_LO0011);
